import { Autocomplete, TextField } from '@mui/material';
import { useAdapterConfigLabels } from '../../hooks/useAdapterServices';

const ALL_LABELS_VALUE = '';

type Props = {
  value: string;
  onChange: (label: string) => void;
};

/** Service list filter: empty value = show all adapter config labels. */
export function ServiceListLabelFilter({ value, onChange }: Props) {
  const { data: labels = ['default'], isLoading } = useAdapterConfigLabels();
  const options = [ALL_LABELS_VALUE, ...labels];
  const displayValue = value || ALL_LABELS_VALUE;

  return (
    <Autocomplete
      disableClearable
      disabled={false}
      loading={isLoading}
      options={options}
      value={displayValue}
      getOptionLabel={option => (option === ALL_LABELS_VALUE ? 'All labels' : option)}
      onChange={(_, v) => onChange(v === ALL_LABELS_VALUE ? '' : (v ?? '').trim() || '')}
      renderInput={params => (
        <TextField
          {...params}
          label="Filter by adapter config label"
          helperText="Show all services or only rows with the selected label."
          sx={{ minWidth: { xs: '100%', sm: 280 } }}
        />
      )}
    />
  );
}
